import React     from 'react';
import PropTypes from 'prop-types';

import ActorMediaVoting from '../../ActorMediaVoting';
import Gallery          from '../../Gallery/Gallery';

import { isActorSeoTest }            from '../../Helper/SeoHelper';
import { getSeoHeadlineTranslation } from '../../../utils/TranslationHelper';
import Flux                          from '../../../flux/Flux';
import Translations                  from '../../../utils/Translations';
import UrlBuilder                    from '../../../utils/UrlBuilder';
import { VXPay, VXPayAction }        from '../../../utils/VXPay';

const ActorSedcards = (props) => {

    const {actorData, sedcard, setSedcard} = props;
    
    const headline = isActorSeoTest(actorData.id) 
        ? <h1 className="actor-pictures__headline--line1">{getSeoHeadlineTranslation('profile_pictures_title_h1', actorData.name)} </h1>
        : <h2 className="actor-pictures__headline--line1">{Translations.get('SexyProfilePhotos')}</h2>
    ;

    const onShowModal = () => {

		VXPay.openSignupOrLogin({
				host: actorData.id,
			},
			new VXPayAction(Flux.Constants.ActionTypes.VXPay.REDIRECT_TO, {
				targetUrl: UrlBuilder.buildActorProfilePictureDetailRoute(actorData.name, 'sedcards'),
			})
		);
	};

    return (
        <div className="container-block">
            <div className="context-box--actor-profile"><div className='context-box__title'>{headline}</div></div>

            <div className="context-box--motive-panel clearfix -padding-sm">
                <div className="col-xs-12 col-sm-12 col-lg-7">
                    <div className="context-box--motive -padding-sm">
                        <div className="box--fixed-ratio -ratio16_10">
                            <div className="box--fixed-ratio__content gallery__frame">
                                <div id="gallery-container" className='h-height-full'>
                                    <Gallery 
                                        actorId              = {actorData.id}
                                        isModelGuestFavorite = {actorData.isFavorite}
                                        onShowModal          = {!Flux.Guest.isLoggedIn() ? onShowModal : null}
                                        sedcard              = {sedcard}
                                        setSedcard           = {setSedcard}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-lg-5">
                    <div className="context-box--motive -padding-top">
                        <div className="context-box--motive__row -margin-small">
                            <h3 className="context-box--motive__title h-disp-inline-block h-vertical-align-top">
                            {getSeoHeadlineTranslation('profile_pictures_sedcards_title')}
                                <br className="hidden-sm-down" />
                            </h3>
                        </div>

                        <div className="row context-box--motive__row -margin-at-sm -margin-middle">
                            <p className="context-box--motive__actor-title h-disp-inline-block">
                                <span className="icon -icon-image-album-lite"></span>
                                <span className="h-ml-5 h-mr-10">{Translations.get('actor_profile.actor_profile_pictures')}</span>
                                <span className="h-color-highlight">{actorData.name}</span>
                            </p>
                        </div>

                        <div className="row context-box--motive__row -margin-small">
                            <div>
                                <div id="js-actor-voting-elements" className="h-mb-10">
                                    <ActorMediaVoting
                                        actor = {{
                                            id: actorData.id,
                                        }}
                                        album = {{
                                            likes:           sedcard.guestRatingLikes,
                                            dislikes:        sedcard.guestRatingDislikes,
                                            isLiked:         sedcard.isLiked,
                                            isDisliked:      sedcard.isDisliked,
                                            totalViews:      sedcard.albumTotalViews,
                                            isFavorite:      sedcard.isFavoriteAlbum || false,
                                            isVotingVisible: sedcard.isVotingVisible,
                                        }}
                                        isSedcard = {true}
                                        isSedcardPinned = {sedcard.isFavoriteAlbum}
                                    />
                                </div>

                                <div className="row context-box--motive__row">
                                    <p className="context-box--motive__video-views h-disp-inline-block h-color-fg-description">
                                        <span className="h-color-fg-description">{Translations.get('TotalViews') + ': '}</span>
                                        <span>{sedcard.albumTotalViews}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ActorSedcards.propTypes = {
    actorData:  PropTypes.object.isRequired,
    navigateTo: PropTypes.func,
    sedcard:    PropTypes.object.isRequired,
    setSedcard: PropTypes.func.isRequired,
};

export default ActorSedcards;
